class TranslationMatrixOption {
	constructor() {
		this.code = '';
		this.text = '';
	}
}

export default TranslationMatrixOption;
